import React from "react";
import Button from "ui/atoms/Button/Button";
import mixpanel from "mixpanel-browser";
import { upgradeAd } from "shared/analytics/mixpanel/adEvents";
import { SubscriptionPlans } from "shared/user/plans";
import Link from "util/Link";
import * as routes from "routes";
import { wordPlural, WordType } from "ui/organisms/Navbar/WordType";

interface Props {
  type: WordType;
}

export default function SetlistSignupBanner({ type }: Props) {
  const lives = wordPlural(type);

  return (
    <div
      className={
        "bg-gradient-to-t to-purple-500 from-purple-800 rounded py-4 px-4 text-white"
      }
    >
      <div className={"mb-4"}>
        <div className={"font-brik leading-none text-2xl text-center"}>
          Want to save your progress?
        </div>

        <div className={"leading-tight text-center text-sm"}>
          Create a free account now to save and get a few extra {lives}!
        </div>
      </div>

      <div className={"flex justify-center"}>
        <Button
          theme="white"
          as={Link}
          outline
          href={routes.auth.signup({})}
          onClick={() => {
            mixpanel.track(upgradeAd.event, {
              [upgradeAd.properties.location]: "Sidebar",
              [upgradeAd.properties.nextUpgrade]: SubscriptionPlans.free,
            });
          }}
        >
          Sign up now!
        </Button>
      </div>
    </div>
  );
}
